import styled from "styled-components";

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
  padding: 1rem;
`;

export const ModalContainer = styled.div`
  background: var(--bg-modal-color);
  border-radius: 12px;
  width: 100%;
  max-width: 900px;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
`;

export const ModalHeader = styled.div`
  padding: 1.5rem;
  border-bottom: 1px solid #e9ecef;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: var(--bg-modal-color);
`;

export const ModalTitle = styled.h2`
  margin: 0;
  font-size: 1.5rem !important;
  font-weight: 600 !important;
  color: var(--text-primary) !important;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 2rem;
  color: #6c757d;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s ease;

  &:hover {
    background: #f8f9fa;
    color: #495057;
  }
`;

export const ModalBody = styled.div`
  padding: 1.5rem;
  overflow-y: auto;
  max-height: calc(90vh - 120px);
`;

export const SearchContainer = styled.div`
  margin-bottom: 1.5rem;
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 0.25rem;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 0.8rem;
  transition: border-color 0.3s ease;

  &:focus {
    outline: none;
    border-color: ${({theme}) => theme.colors['primary-color']};
  }

  &::placeholder {
    color: #6c757d;
  }
`;

export const EcheckList = styled.div`
  box-shadow: 0 10px 16px 10px rgba(0, 0, 0, 0.1);
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const EcheckItem = styled.div`
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 1rem;
  transition: all 0.2s ease;
  background-color: var(--bg-color);

  &:hover {
    border-color: ${({theme}) => theme.colors['primary-color']};
    background: transparent;
  }
`;

export const EcheckHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 0.75rem;
`;

export const EcheckInfo = styled.div`
  width: 50%;
`;

export const ReceiverName = styled.h3`
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const EcheckDetails = styled.div`
  font-size: 0.875rem;
  color: var(--text-primary);
  margin-bottom: 0.5rem;
`;

export const EcheckValue = styled.div`
  font-size: 1.25rem;
  font-weight: 700;
  color: #28a745;
  margin-right: 1rem;
`;

export const StatusBadge = styled.span`
  padding: 0.25rem 0.75rem;
  border-radius: 16px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-right: 0.75rem;

  &.created {
    background: #fff3cd;
    color: #856404;
    border: 1px solid #ffeaa7;
  }

  &.paid {
    background: #d4edda;
    color: #155724;
    border: 1px solid #c3e6cb;
  }

  &.canceled {
    background: #f8d7da;
    color: #721c24;
    border: 1px solid #f5c6cb;
  }
`;

export const ActionButton = styled.button`
  background: ${({theme}) => theme.colors['filter-button-background']};
  color: ${({theme}) => theme.colors['filter-button-color']};
  border: ${({theme}) => theme.colors['filter-button-border']};
  padding: 0.5rem 1rem;
  border-radius: 6px;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 5rem;
  justify-content: center;

  &:hover {
    background: ${({theme}) => theme.colors['filter-button-background']};
    transform: translateY(-1px);
  }
`;

export const EcheckMeta = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  margin-top: 0.75rem;
  padding-top: 0.75rem;
  border-top: 1px solid #e9ecef;
  font-size: 0.875rem;
`;

export const MetaItem = styled.div`
  color: var(--text-primary);
  
  strong {
    color: var(--text-primary);
    font-weight: 600;
  }
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 3rem 1rem;
  color: var(--text-primary);
`;

export const EmptyIcon = styled.div`
  font-size: 3rem;
  margin-bottom: 1rem;
`;